import { createContext, useEffect, useState } from 'react';
import useLocations from '../hooks/useLocations';

export const FiltersContext = createContext();

const FiltersProvider = ({ children }) => {
    const { data } = useLocations();
    const [filters, setFilters] = useState({
        unidade: {
            value: '',
            label: 'Todos'
        },
        ano: {
            value: new Date().getFullYear().toString(),
            label: new Date().getFullYear().toString(),
        },
        competencia: {
            value: '',
            label: 'Todos'
        }
    });

    const locations = data || [];

    useEffect(() => {
        setFilters({
            unidade: {
                value: locations.map((location) => location.co_cnes).join(','),
                label: 'Todos'
            },
            ano: {
                value: new Date().getFullYear().toString(),
                label: new Date().getFullYear().toString(),
            },
            competencia: {
                value: '',
                label: 'Todos'
            }
        });
    }, [data]);

    const handleChangeFilters = (values) => {
        setFilters(values);
    };

    const handleResetFilters = () => {
        setFilters({
            unidade: {
                value: locations.map((location) => location.co_cnes).join(','),
                label: 'Todos'
            },
            ano: {
                value: new Date().getFullYear().toString(),
                label: new Date().getFullYear().toString(),
            },
            competencia: {
                value: '',
                label: 'Todos'
            }
        });
    };

    return (
        <FiltersContext.Provider
            value={{
                filters,
                handleChangeFilters,
                handleResetFilters
            }}
        >
            {children}
        </FiltersContext.Provider>
    );
};

export default FiltersProvider;
